import { useState, useEffect, useRef } from 'react';

function useObserver() {
    const [isVisible, setIsVisible] = useState(false);
    const observedDiv = useRef(null);
 
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {  }
        );
        // we also instantiate the resizeObserver and we pass
        // the event handler to the constructor
        const currentElement = observedDiv.current;
        if (currentElement) observer.observe(currentElement);

        return () => {
            if (currentElement) observer.unobserve(currentElement);
        };
    },
        // only update the effect if the ref element changed
        [])


        return [observedDiv, isVisible];
}

    export default useObserver;